// Presavijanje teksta za trazenje: bez dijakritike i malim slovima.
//
// Na kasi se tipka brzo i bez kvacica, pa "cok" mora naci "Čokolada", a "sec"
// mora naci "Šećer". Obican toLowerCase() to ne radi - "c" i "č" su za njega
// razliciti znakovi.
//
// Ista tablica kao u helpers/globalSearch.js na posluzitelju, da ekran i
// posluzitelj nadu isto.

const IZ = 'ČĆŽŠĐčćžšđÁÀÂÄÃÅáàâäãåÉÈÊËéèêëÍÌÎÏíìîïÓÒÔÖÕóòôöõÚÙÛÜúùûüÝýÑñÇç'
const U = 'CCZSDcczsdAAAAAAaaaaaaEEEEeeeeIIIIiiiiOOOOOoooooUUUUuuuuYyNnCc'

if (IZ.length !== U.length) {
  throw new Error('presavij: tablice IZ i U moraju biti iste duljine')
}

/**
 * "Čokolada Dorina" -> "cokolada dorina"
 */
const presavij = (tekst) =>
  String(tekst === undefined || tekst === null ? '' : tekst)
    .replace(/[\s\S]/g, (z) => {
      const at = IZ.indexOf(z)
      return at === -1 ? z : U[at]
    })
    .toLowerCase()

export { presavij }
export default presavij
